import React from 'react';
import { BookOpen, Dumbbell, Brain, Target, Users, Zap } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export const MegapackOverview = () => {
  return <section className="py-12 md:py-24 bg-gradient-to-b from-navy-950 to-navy-900 border-t border-navy-800 relative overflow-hidden" data-id="element-197">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl h-[400px] bg-gold-500/5 blur-[100px] pointer-events-none rounded-full" data-id="element-198" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-199">
        <FadeIn data-id="element-200">
          <div className="text-gold-500 font-bold tracking-widest uppercase text-sm mb-4" data-id="element-201">
            Sistema N°1 para Armadores de Voleibol en Argentina
          </div>
          <h2 className="text-5xl md:text-7xl font-bebas text-white mb-2" data-id="element-202">
            ARMADOR DE ÉLITE™
          </h2>
          <h3 className="text-3xl md:text-4xl font-bebas text-gray-400 mb-6" data-id="element-203">
            MEGAPACK — SISTEMA COMPLETO
          </h3>
          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-204">
            6 Tomos + 6 Bonos — Todos los niveles —{' '}
            <strong className="text-white" data-id="element-205">Todo resuelto.</strong>
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 max-w-5xl mx-auto mb-8 md:mb-16" data-id="element-206">
          <FadeIn delay={0.1} className="bg-navy-900 border border-navy-700 p-4 md:p-6 rounded-xl flex items-center gap-3 md:gap-4 text-left" data-id="element-207">
            <div className="bg-navy-800 p-2 md:p-3 rounded-lg" data-id="element-208">
              <BookOpen className="w-6 h-6 text-gold-500" data-id="element-209" />
            </div>
            <div className="font-medium text-base md:text-lg" data-id="element-210">
              📖 +600 páginas de contenido estructurado
            </div>
          </FadeIn>
          <FadeIn delay={0.2} className="bg-navy-900 border border-navy-700 p-4 md:p-6 rounded-xl flex items-center gap-3 md:gap-4 text-left" data-id="element-211">
            <div className="bg-navy-800 p-2 md:p-3 rounded-lg" data-id="element-212">
              <Target className="w-6 h-6 text-gold-500" data-id="element-213" />
            </div>
            <div className="font-medium text-base md:text-lg" data-id="element-214">
              🏐 80+ ejercicios y drills listos para aplicar hoy
            </div>
          </FadeIn>
          <FadeIn delay={0.3} className="bg-navy-900 border border-navy-700 p-4 md:p-6 rounded-xl flex items-center gap-3 md:gap-4 text-left" data-id="element-215">
            <div className="bg-navy-800 p-2 md:p-3 rounded-lg" data-id="element-216">
              <Brain className="w-6 h-6 text-gold-500" data-id="element-217" />
            </div>
            <div className="font-medium text-base md:text-lg" data-id="element-218">
              🧠 Técnica · Táctica · Distribución · Liderazgo · Físico ·
              Mentalidad
            </div>
          </FadeIn>
          <FadeIn delay={0.4} className="bg-navy-900 border border-navy-700 p-4 md:p-6 rounded-xl flex items-center gap-3 md:gap-4 text-left" data-id="element-219">
            <div className="bg-navy-800 p-2 md:p-3 rounded-lg" data-id="element-220">
              <Zap className="w-6 h-6 text-gold-500" data-id="element-221" />
            </div>
            <div className="font-medium text-base md:text-lg" data-id="element-222">
              📊 Planificación · Toma de decisiones · Preparación mental ·
              Comunicación
            </div>
          </FadeIn>
          <FadeIn delay={0.5} className="bg-navy-900 border border-navy-700 p-4 md:p-6 rounded-xl flex items-center gap-3 md:gap-4 text-left md:col-span-2 lg:col-span-2" data-id="element-223">
            <div className="bg-navy-800 p-2 md:p-3 rounded-lg" data-id="element-224">
              <Zap className="w-6 h-6 text-gold-500" data-id="element-225" />
            </div>
            <div className="font-medium text-base md:text-lg" data-id="element-226">
              ⚡ Funciona desde tu próximo entrenamiento
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-227">
          <div className="inline-block bg-navy-900 border border-navy-700 rounded-2xl p-6 md:p-8" data-id="element-228">
            <h4 className="text-xl font-bold text-white mb-6 uppercase tracking-wide" data-id="element-229">
              Niveles y enfoques incluidos:
            </h4>
            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-lg font-medium" data-id="element-230">
              <span className="flex items-center gap-2" data-id="element-231">
                <span className="w-3 h-3 rounded-full bg-green-500" data-id="element-232"></span>{' '}
                Iniciación
              </span>
              <span className="flex items-center gap-2" data-id="element-233">
                <span className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-234"></span>{' '}
                Intermedio
              </span>
              <span className="flex items-center gap-2" data-id="element-235">
                <span className="w-3 h-3 rounded-full bg-red-500" data-id="element-236"></span>{' '}
                Avanzado
              </span>
              <span className="flex items-center gap-2" data-id="element-237">🧠 Táctica</span>
              <span className="flex items-center gap-2" data-id="element-238">💪 Físico</span>
              <span className="flex items-center gap-2" data-id="element-239">🎯 Mental</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};